import clsx from "clsx";
import type { ReactNode } from "react";
import styles from "./TransactionHistoryTable.module.css";

/* TransactionHistoryPagination component for navigating pages in the transaction history table
  @param children - The content to display inside the button
  @param onClick - The click handler for the button
  @param disabled - Whether the button is disabled
  @param className - Additional CSS class names for styling
  @returns A button representing the TransactionHistoryPagination
*/
export const TransactionHistoryPagination = ({
  children,
  onClick,
  disabled,
  className,
}: {
  children: ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
}) => {
  const classNames = clsx(
    className,
    disabled ? styles.pageBtnDisabled : styles.pageBtn
  );

  return (
    <button
      type="button"
      onClick={onClick}
      className={classNames}
      disabled={disabled}
    >
      {children}
    </button>
  );
};
